// extracted by mini-css-extract-plugin
module.exports = {"image":"BlankScreen_image__3XIPJ","imageText":"BlankScreen_imageText__1KBLt"};